const HoveredToast = ({ points, className = '' }) => {
    return (
        <div className={`absolute ${className}`}>
            <div className="relative ">
                <div className="absolute top-[50%] translate-y-[-50%] -right-2 w-0 h-0 border-t-[10px] border-b-[10px] border-l-[9px] border-t-transparent border-b-transparent border-l-[#BCD3CE]"></div>

                <div
                    className={`bg-[#BCD3CE] rounded-[.25rem] py-[.65rem] px-3 text-[#3C665D] font-semibold flex items-center gap-3  `}
                >
                    <p>{points} IP left till the next stage</p>
                </div>
            </div>
        </div>
    );
};

export default HoveredToast;
